var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 37",
    style: {
      enableBackground: "new 0 0 21 37"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,36C3.7,36-1,31.3-1,25.5v-16C-1,3.7,3.7-1,9.5-1C15.3-1,20,3.7,20,9.5v16C20,31.3,15.3,36,9.5,36z M9.5,1 C4.8,1,1,4.8,1,9.5v16C1,30.2,4.8,34,9.5,34c4.7,0,8.5-3.8,8.5-8.5v-16C18,4.8,14.2,1,9.5,1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 9.5,
    cy: 7.5,
    r: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.da77c068aeee77ba0cc336d613ceb21f.svg";
export { ForwardRef as ReactComponent };